import { jsx as _jsx } from "react/jsx-runtime";
import '@styles/webdesktop/stylesheets/baseNumeric.scss';
import React from 'react';
import { Stack } from '@front/sharedcomponents/Stack/Stack';
import { Spacing } from '@front/sharedcomponents/Variables';
import { TooltipDecorator } from '../../../Tooltip/TooltipDecorator';
import { TooltipBehavior } from '../../../Tooltip/TooltipTypes';
import { Background, BorderSize, Foreground, State, Stroke } from '@front/sharedcomponents/Styles';
export const NumericContainer = ({ children, className = '', disabled = false, validationError }) => {
    const [isActive, setIsActive] = React.useState(false);
    const containerClassName = [
        'numeric',
        Background.Secondary,
        Foreground.Secondary,
        Stroke.General,
        BorderSize.Solid1,
        Background.Input,
        Stroke.Input,
        disabled ? State.Disabled : '',
        isValidString(validationError) ? State.Error : '',
        isActive ? State.Active : '',
        className
    ]
        .filter(Boolean)
        .join(' ');
    return (_jsx(TooltipDecorator, { behavior: TooltipBehavior.Error, content: validationError, children: _jsx(Stack, { className: containerClassName, spacing: Spacing.None, onFocus: () => setIsActive(true), onBlur: () => setIsActive(false), children: children }) }));
};
NumericContainer.displayName = 'NumericContainer';
